"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var load_themed_styles_1 = require("@microsoft/load-themed-styles");
load_themed_styles_1.loadStyles([{ "rawString": ".root_8d84f67a{position:relative;padding:10px 84px;cursor:pointer}.root_8d84f67a .ms-Link{font-size:12px}\n" }]);
exports.root = "root_8d84f67a";
//# sourceMappingURL=GroupShowAll.scss.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/office-ui-fabric-react/lib/components/GroupedList/GroupShowAll.scss.js
// module id = 935
// module chunks = 0